import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-fornecedor-cadastro',
  templateUrl: './fornecedor-cadastro.component.html',
})
export class FornecedorCadastroComponent {

  @Input() formulario!: FormGroup;
}
